import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import Link from 'components/Link';
import Image from 'components/Image';
import ImageV2 from 'components_v2/common/ImageV2';
import makeRequest from 'utils/makeRequest';
import { dateToStringWithFormat } from 'utils/dateUtils';
import InViewObserver from 'components/InViewObserver/InViewObserver';
import { UseIntersectionObeserver } from 'routes/home/layouts/India/context';
import s from './PlaneLayoutWithAuthor.scss';
//import PlaneLayoutListItems from './PlaneLayoutListItems';
import Listingheader from '../../common/ListingheaderV2';
import InterSectionBorder from '../../../../../components_v2/common/InterSectionBorder';

class PlaneLayoutWithAuthor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hideOpinionSec: false,
      opinionList: [],
    };
  }

  loadSection = () => {
    const { sectionData = {} } = this.props;
    //for loading content
    if (sectionData && !Array.isArray(sectionData) && sectionData.dataUrl) {
      this.loadSectionData(sectionData.dataUrl);
    } else if (
      sectionData &&
      !Array.isArray(sectionData) &&
      sectionData.items &&
      Array.isArray(sectionData.items) &&
      sectionData.items.length > 0
    ) {
      this.setState({
        opinionList: sectionData.items,
      });
    }
  };

  loadSectionData = dataUrl => {
    makeRequest.get(dataUrl, {}, 'skipfeedengine').then(data => {
      if (data && data.data && data.data.length > 0) {
        this.setState({
          opinionList: data.data,
        });
      }
    });
  };

  getCardList = data => {
    const { sectionData = {} } = this.props;
    const ImageElement = this.context ? ImageV2 : Image;
    return data.map((itemobj, index) => (
      <div
        className={`${s.item} ${s.listItem} ${
          itemobj.cs && itemobj.cs === 'prime' ? s.primeitem : ''
        }`}
        key={itemobj.id}
      >
        {/* s.primeitem will be applied when story come with prime tag  */}
        <Link
          to={itemobj.wu}
          data-ga={`${this.getItemGA(itemobj.wu, index + 1)}`}
          target={itemobj.target === '_blank' ? itemobj.target : ''}
          ga4Data={
            sectionData?.ga4Type && [
              {
                event: 'user_click',
                type: `${sectionData?.ga4Type ? sectionData?.ga4Type : ''}`,
                category: 'story_click',
                story_no: `${index + 1}`,
                msid: itemobj?.id,
              },
            ]
          }
        >
          <div className={s.author_details}>
            <span className={s.au_img}>
              <ImageElement
                src={itemobj.au_img}
                alt={itemobj.au}
                lazyload
                placeHolderSrc="https://static.toiimg.com/photo/msid-25581306/25581306.jpg"
              />
            </span>
            <div className={s.auInfo}>
              <span className={s.au_name}>{itemobj.au}</span>
              {itemobj.catgery_txt && (
                <div className={s.auCategory}>{itemobj.catgery_txt}</div>
              )}
            </div>
          </div>
          <div className={s.headingtext}>
            {itemobj.hl}{' '}
            {itemobj.cs && itemobj.cs === 'prime' ? (
              <i className="opiniontoiplus" />
            ) : null}
          </div>
          {itemobj.desc && <p>{itemobj.desc}</p>}
          {itemobj.date && (
            <div className={s.au_info}>
              {dateToStringWithFormat(
                itemobj.date,
                'MMMM DD, YYYY, HH:mm A [IST]',
              )}
            </div>
          )}
        </Link>
      </div>
    ));
  };

  getItemGA = (itemText, index) => {
    const { gaCategory, gaAction } = this.props;
    const gaWithCategoryAction =
      gaCategory && gaAction
        ? `${gaCategory}|${gaAction}_${index}|${itemText}`
        : `Click-Opinion|${itemText}/${index}`;
    return gaWithCategoryAction;
  };

  render() {
    const settings = {
      slidesToShow: 2,
      slidesToScroll: 2,
      arrows: true,
      dots: true,
      infinite: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
          },
        },
      ],
    };
    if (this.state.hideOpinionSec) {
      // console.log('this.state.isParentNeedToHide is set to true');
      return null;
    }

    const { sectionData = {} } = this.props;
    const listItems = this.state.opinionList;
    let sliderItems;
    if (
      listItems instanceof Array &&
      listItems[0] &&
      (listItems[0].data || listItems[0].items)
    ) {
      sliderItems = listItems[0].data || listItems[0].items;
    } else if (listItems instanceof Array) {
      sliderItems = listItems;
    }
    const sectionName = sectionData.name;
    const scrollGAAttr = {
      ...(sectionData.onScrollGA &&
        sectionData.id && { 'data-scrollga': sectionData.id }),
    };
    return (
      <InViewObserver
        inViewCallback={() => {
          this.loadSection();
        }}
        viewMargin="500px 0px 500px 0px"
      >
        {sliderItems instanceof Array &&
          sliderItems.length > 0 && (
            <>
              <div className={s.section_wrapper} {...scrollGAAttr}>
                {sectionData.border &&
                  sectionData.border === 'top' && (
                    <InterSectionBorder border={sectionData.border} />
                  )}
                {sectionName ? (
                  <Listingheader
                    headingname={sectionName}
                    headingLink={sectionData.link || sectionData.path}
                    newga={`${sectionName}Section_Actions#${sectionName}_HeadingClick`}
                    overrideClass={this.props.overrideClass}
                    target={sectionData.target}
                    ga4Type={sectionData?.ga4Type}
                    ga4Category={sectionData?.ga4Category}
                  />
                ) : null}
                <div className={`${'grid_wrapper'} ${sectionData.className}`}>
                  <div className={`${'col_l_8'}`}>
                    <div
                      ref={el => {
                        if (el) {
                          this.slidesContainer = el;
                        }
                      }}
                      className={`${s.opinion_list} slick_UI `}
                    >
                      {sliderItems instanceof Array && (
                        <Slider {...settings}>
                          {this.getCardList(sliderItems)}
                        </Slider>
                      )}
                    </div>
                  </div>
                  <div className={`${'col_l_4 hide_m'}`}>
                    {this.props.children}
                  </div>
                </div>
              </div>
            </>
          )}
      </InViewObserver>
    );
  }
}
PlaneLayoutWithAuthor.contextType = UseIntersectionObeserver;
PlaneLayoutWithAuthor.propTypes = {
  sectionData: PropTypes.shape({}).isRequired,
  isWapView: PropTypes.bool,
  children: PropTypes.element,
};

PlaneLayoutWithAuthor.defaultProps = {
  isWapView: false,
  children: undefined,
};

export default PlaneLayoutWithAuthor;
